import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';

import LessonCreate from './create';
import LessonList from './list';
import LessonShow from './show';
import LessonEdit from './edit';

export default {
    create: LessonCreate,
    list: LessonList,
    show: LessonShow,
    edit: LessonEdit,
    icon: SentimentVerySatisfiedIcon
};